import { Injectable } from '@angular/core';
import { FlyoutToday } from '@com-delta-idp/mnx-capability-flyout-ui';
import {
  APP_MESSAGES_ERROR,
  AppConfigService,
  DashboardResponse,
  getIsDelta,
  HeaderFooterMachCore
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { take } from 'rxjs/operators';
import { DEFAULT_ERROR_MESSAGE } from '../../models/constants/today/today-trip.constants';
import {
  IDP_APP,
  MyTripEndpointKeys
} from '../../models/constants/today/todays-trip.enums';
import { TodaysTrip } from '../../models/interfaces/todays-trip/todays-trip.interface';
import * as HelperMethods from '../../utils/todays-trip/flyout-today-trip-helper.utils';
import * as Methods from '../../utils/todays-trip/flyout-today-trip.utils';
import { FlyoutTodayLabelsAdapterService } from './flyout-today-labels-adapter.service';
import { FlyoutTodayTripInfoAdapterService } from './flyout-today-trip-info-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class FlyoutTodayAdapterService {
  checkInPath!: string;
  rebookFlow!: boolean;
  constructor(
    private tripInfoAdapter: FlyoutTodayTripInfoAdapterService,
    private labelsAdapter: FlyoutTodayLabelsAdapterService,
    private appConfig: AppConfigService
  ) {
    this.appConfig
      .getConfigValue(IDP_APP.MY_TRIPS, MyTripEndpointKeys.CHECK_IN_AWS_URL)
      .pipe(take(1))
      .subscribe((value: string) => {
        this.checkInPath = value;
      });
    this.appConfig
      .getConfigValue(IDP_APP.MY_TRIPS, MyTripEndpointKeys.REBOOK_ME_FLOW)
      .pipe(take(1))
      .subscribe((value: string) => {
        this.rebookFlow = Boolean(value);
      });
  }

  getContent(
    session: DashboardResponse,
    todayTrip: TodaysTrip,
    errorMessages: APP_MESSAGES_ERROR,
    contentHeaderFooter: HeaderFooterMachCore
  ): FlyoutToday {
    return {
      todayTrip: this.tripInfoAdapter.getTodayTripsInformation(
        todayTrip,
        session,
        contentHeaderFooter
      ),
      checkInPath: this.checkInPath,
      rebookFlag: this.rebookFlow,
      errorMessages: HelperMethods.errorMessageMethod(todayTrip, errorMessages),
      iropErrorMessage: !!todayTrip?.trip?.iropMessage,
      tripLinkFormAction: Methods.getTripLinkAction(todayTrip),
      isDelta: getIsDelta(contentHeaderFooter),
      viewTripDetailsOpenNewTab:
        Methods.getViewTripDetailsOpenNewTab(contentHeaderFooter),
      findAlternateOpenNewTab:
        Methods.getFindAlternateOpenNewTab(contentHeaderFooter),
      arrowFlightDetailsOpenNewTab:
        Methods.getArrowFlightDetailsOpenNewTab(contentHeaderFooter),
      viewBoardingPassOpenNewTab:
        Methods.getViewBoardingPassOpenNewTab(contentHeaderFooter),
      checkInOpenNewTab: Methods.getCheckInOpenNewTab(contentHeaderFooter),
      showIropModel: HelperMethods.getShowIropModel(todayTrip),
      disableViewLink: Methods.getDisableViewLink(todayTrip),
      labels: this.labelsAdapter.getTripLabels(contentHeaderFooter),
      defaultErrorMessage: DEFAULT_ERROR_MESSAGE
    };
  }
}
